import * as React from "react";
import { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { DataLake } from "@graylog/enterprise-api";
import UserNotification from "util/UserNotification";
import useSelectedDataLake from "data-lake/hooks/useSelectedDataLake";
import RetrievalHelp from "data-lake/RetrievalHelp";
import DataLakeRetrievalActionForm from "data-lake/components/DataLakeActionModals/DataLakeRetrievalActionForm";
import { toInternalTime } from "data-lake/logic/Utils";
import useUserDateTime from "hooks/useUserDateTime";
import { INTERNAL_DATA_LAKE_TYPE } from "data-lake/Constants";
const onRetrieveInternalMessages = ({ data_lake_id, stream_ids, inclusion_type, field_filters, operator }, from, to) => {
  const request = {
    type: INTERNAL_DATA_LAKE_TYPE,
    data_lake_id,
    stream_ids,
    inclusion_type,
    field_filters,
    operator
  };
  return DataLake.retrieveBulkRetrievalRequest(request, from, to);
};
const RetrievalArchiveModal = ({
  archiveStreamId = void 0,
  calculateEstimatedSize = void 0,
  onToggleModal,
  defaultFieldFilters = void 0,
  defaultFieldOperator = void 0,
  defaultTimeRange = void 0,
  onRetrieveMessages = onRetrieveInternalMessages
}) => {
  const { selectedDataLake } = useSelectedDataLake();
  const queryClient = useQueryClient();
  const { userTimezone } = useUserDateTime();
  const dataLakeLabel = selectedDataLake.title ? `the following Data Lake: ${selectedDataLake.title}` : "the selected Data Lake";
  const onRestoreSubmit = useCallback(
    (values) => {
      const internalFrom = values.from ? toInternalTime(values.from, userTimezone) : "";
      const internalTo = values.to ? toInternalTime(values.to, userTimezone) : "";
      onRetrieveMessages(values, internalFrom, internalTo).then(() => {
        UserNotification.success(`Data Lake was submitted successfully.`, "Success");
      }).catch((error) => {
        UserNotification.error(`An error occurred while retrieving data. ${error}`);
      }).finally(() => {
        queryClient.invalidateQueries({
          queryKey: ["data-lake"]
        });
        onToggleModal();
      });
    },
    [onRetrieveMessages, onToggleModal, queryClient, userTimezone]
  );
  return /* @__PURE__ */ React.createElement(
    DataLakeRetrievalActionForm,
    {
      calculateEstimatedSize,
      modalTitle: "Retrieving from Data Lake",
      show: true,
      onHide: onToggleModal,
      submitButtonText: "Retrieve",
      dataLakeId: selectedDataLake.id,
      streamIds: [archiveStreamId],
      onSubmit: onRestoreSubmit,
      defaultTimeRange,
      defaultFieldOperator,
      defaultFieldFilters
    },
    /* @__PURE__ */ React.createElement("p", null, "You are about to retrieve data from ", dataLakeLabel, "."),
    /* @__PURE__ */ React.createElement(RetrievalHelp, null)
  );
};
export default RetrievalArchiveModal;
